import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';
import ReportService from '../../../core/service/ReportService'
import { languageOptions, ReportSettingsFrequency } from '../../../core/constants/common'
import useHasPermission from '../../../core/hooks/useHasPermission';

function ReportPage({ t }) {
    const [selectedLanguage, setSelectedLanguage] = useState('en-gb')
    const [selectedFrequency, setSelectedFrequency] = useState(ReportSettingsFrequency.CALENDAR_YEAR)
    const [loading, setLoading] = useState(false)
    const { hasSettingsUpdatePermission } = useHasPermission();

    useEffect(() => {
        fetchLanguageSettings()
    }, [])

    const fetchLanguageSettings = async () => {
        try {
            setLoading(true)
            const response = await ReportService.getReportSettings();
            // console.log(response, 'res')
            if (response.data?.language) {
                setSelectedLanguage(response.data.language)
            }
            if (response.data?.frequency) {
                setSelectedFrequency(response.data.frequency)
            }
        } catch (error) {
            toast.error('Failed to fetch report settings')
        } finally {
            setLoading(false)
        }
    }

    const handleLanguageChange = async (e) => {
        const newLanguage = e.target.value
        try {
            setLoading(true)
            await ReportService.updateReportSettings({ language: newLanguage })
            setSelectedLanguage(newLanguage)
            toast.success('Language settings updated successfully')
        } catch (error) {
            console.error('Update failed:', error?.response?.data || error.message)
            toast.error('Failed to update language settings')
        } finally {
            setLoading(false)
        }
    }

    const handleFrequencyChange = async (e) => {
        const newFrequency = e.target.value
        try {
            setLoading(true)
            await ReportService.updateReportSettings({ frequency: newFrequency })
            setSelectedFrequency(newFrequency)
            toast.success('Reporting frequency updated successfully')
        } catch (error) {
            console.error('Update failed:', error?.response?.data || error.message)
            toast.error('Failed to update reporting frequency')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="">
            <div className="List_header pb-2">
                <h5 className="MH m-0">{t('ReportSettings.label')}</h5>
            </div>
            <div className='row  m-0'>
                <div className='col-lg-12 px-0 pb-3'>
                    <p className='mb-0'>{t('ReportLangSettingsHelper.label')}</p>
                </div>
                <div className="col-md-5 px-0">
                    <Form.Group>
                     
                        <Form.Select
                            value={selectedLanguage}
                            onChange={handleLanguageChange}
                            disabled={loading || !hasSettingsUpdatePermission()}
                        >
                            {languageOptions.map((option) => (
                                <option key={option.code} value={option.code}>
                                    {option.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </div>
            </div>
            <div className='row  m-0 mt-3'>
                <div className='col-lg-12 px-0 pb-3'>
                    <p className='mb-0'>{t('ReportingFrequencyHelper.label')}</p>
                </div>
                <div className="col-md-5 px-0">
                    <Form.Group>
                        <Form.Select
                            value={selectedFrequency}
                            onChange={handleFrequencyChange}
                            disabled={loading || !hasSettingsUpdatePermission()}
                        >
                            <option value={ReportSettingsFrequency.CALENDAR_YEAR}>
                                {t('CalendarYear.label')}
                            </option>
                            <option value={ReportSettingsFrequency.FINANCIAL_YEAR}>
                                {t('FinancialYear.label')}
                            </option>
                        </Form.Select>
                    </Form.Group>
                </div>
            </div>
        </div>
    )
}

export default withTranslation()(ReportPage)